import React from 'react';
import ReportPage from './components/ReportPage';
import KeysByCompanyByTagByStatusList from './components/KeysByCompanyByTagByStatusList';
import { useAppSelector } from '../../hooks';

function KeysByCompanyByTagByStatus() {
  const currentUser = useAppSelector((state) => state.auth);
  return (
    <ReportPage title="Keys by company by tag by status">
      <KeysByCompanyByTagByStatusList currentUser={currentUser} />
    </ReportPage>
  );
}

export default KeysByCompanyByTagByStatus;
